import { Address, Country } from '@dsivd/prestations-ng';

import { CadorReference } from './cador-reference';
import { PersonNomenclature } from './person-nomenclature';

export class InformationApplicant {

    civility: PersonNomenclature;

    lastName: string;

    firstName: string;

    birthDate: number[] = null;

    avs: string;

    nationality: Country;

    dateOfArrival: number;

    address: Address;

    additionalAddress: string;

    email: string;

    phone: string;

    // public residencePermit: ResidencePermit;
    residencePermit: CadorReference;

    contactPreference: CadorReference;

}
